import { render, staticRenderFns } from "./feedbackList.vue?vue&type=template&id=4fc0dd1c&scoped=true"
import script from "./feedbackList.vue?vue&type=script&lang=js"
export * from "./feedbackList.vue?vue&type=script&lang=js"
import style0 from "./feedbackList.vue?vue&type=style&index=0&id=4fc0dd1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc0dd1c",
  null
  
)

export default component.exports